import MOpenBaseAPI from '../open-base'

// 行动纪录
class ActionRecordService extends MOpenBaseAPI {
  /**
   * 获取预警语音信息
   * @param searchStr : 为 window.location.search 的结果
   */
  fetchWarningVoice(searchStr) {
    return this.get({
      url: `/api/v1/xreports/front/voice/detail${searchStr}`,
    })
  }

  fetchVoice(recordId) {
    return this.get({
      url: `/api/v1/xreports/front/voice/detail?recordId=${recordId}`,
    })
  }

  fetchWarnRecordDetails(recordIds) {
    return this.get({
      url: `/api/v1/xreports/front/warn/record/details?recordIds=${recordIds}`,
    })
  }

  fetchComplaintDetail(rowId) {
    return this.post({
      url: '/api/v1/xreports/cem/complaint/detail',
      data: { dataRowId: rowId },
    })
  }

  // 审核页面获取详情
  auditWarnRecordDetails(recordIds) {
    return this.get({
      url: `/api/v1/xreports/front/warn/record/audit-details?recordIds=${recordIds}`,
    })
  }

  // 审核状态变更
  updateAuditStatus(ids, status) {
    return this.get({
      url: `/api/v1/xreports/front/warn/record/updateAuditStatus?recordIdList=${ids}&auditStatus=${status}`,
    })
  }

  // 报警记录已读
  recordIsShowForComplaint(ids, channelSource) {
    return this.get({
      url: `/api/v1/xreports/cem/complaint/voice/click?dataSoleId=${ids}&channelSource=${channelSource}`,
    })
  }

  // 报警记录已读
  recordIsShow(ids, channelSource) {
    return this.get({
      url: `/api/v1/xreports/front/voice/click?recordIds=${ids}&channelSource=${channelSource}`,
    })
  }

  // 获取工单列表
  getWorkflowList(list) {
    return this.post({
      // url: `/api/v1/xreports/work-order/list-by-attribute`,
      url: `/api/v1/xreports/process/work-order/list-by-attribute`,
      data: {
        attributeKey: 'warn_record_id',
        attributeValues: list,
      },
    })
  }

  // 获取工单列表新
  getWorkflowListNew(list, sourceId) {
    return this.post({
      url: `/api/v1/xreports/process/work-order/list-by-attribute`,
      data: {
        attributeKey: 'data_row_id',
        attributeValues: list,
        dataSourceId: sourceId,
      },
    })
  }
  getCommentWorkflowList(data) {
    return this.post({
      url: `/api/v1/xreports/process/work-order/list-by-attribute`,
      data,
    })
  }

  // 获取预警列表
  getRecordList(data) {
    return this.post({
      url: `/api/v1/xreports/m/warn/record/list`,
      data,
    })
  }

  // 获取语音关联差评数量
  getRelevanceWarnNum(data) {
    return this.post({
      url: `/api/v1/xreports/cem/complaint/queryComplaintVoiceCount`,
      data,
    })
  }

  // 获取预警处理记录
  getWarningProcessRecords(data) {
    return this.post({
      url: `/api/v1/xreports/warn/record/handle-record/list`,
      data,
    })
  }

  // 新增预警处理记录
  updateWarningProcessRecordForComplaint(data) {
    return this.post({
      url: `/api/v1/xreports/cem/complaint/operate/add`,
      data,
    })
  }

  // 新增预警处理记录
  updateWarningProcessRecord(data) {
    return this.post({
      url: `/api/v1/xreports/warn/record/handle-record/add`,
      data,
    })
  }

  // 预警纠错反馈
  warningRecordFeedback(data) {
    return this.post({
      url: `/api/v1/xreports/warn/record/error/correction`,
      data,
    })
  }
  // 客需纠错反馈
  demandRecordFeedback(data) {
    return this.post({
      url: `/api/v1/xreports/warn/record/demand-complaint/correction`,
      data,
    })
  }

  // 获取纠错列表
  getFeedbackList(params) {
    return this.get({
      url: `/api/v1/xreports/warn/record/error-type/list`,
      params,
    })
  }

  // 更新预警处理状态
  udpateWarnHandleStatus(data) {
    return this.post({
      url: `/api/v1/xreports/warn/record/handle-status/update`,
      data,
    })
  }
  // 更新预警处理状态
  udpateWarnHandleStatusForComplaint(data) {
    return this.post({
      url: `/api/v1/xreports/cem/complaint/handle-status/update`,
      data,
    })
  }

  // 查询预警处理状态
  getWarningHandleStatus(params) {
    return this.get({
      url: `/api/v1/xreports/warn/record/handle-status/detail`,
      params,
    })
  }

  // 获取预警处理记录 新整合版本
  getWarningProcessRecordsNew(params) {
    return this.get({
      url: `/api/v1/xreports/warn/record/operate/list`,
      params,
    })
  }

  // 获取语音处理记录
  getWarningProcessRecordsNewForComplaint(params) {
    return this.get({
      url: `/api/v1/xreports/cem/complaint/operate/list`,
      params,
    })
  }

  // 获取预警 通话记录
  getCallRecordList(data) {
    return this.post({
      url: `/api/v1/xreports/warn/record/link-voice/list`,
      data,
    })
  }

  // 获取差评相关标签概率
  getBadPointLabelHitRate(data) {
    return this.post({
      url: `/api/v1/xreports/cem/dataCube/calBadPointLabelHitRate`,
      data,
    })
  }

  // 获取大数据测算点评样本量
  getCommentCount(data) {
    return this.post({
      url: `/api/v1/xreports/cem/dataCube/commentCount`,
      data,
    })
  }

  // 通过分享的recordId获取语音
  getAudioByShareRecordId(params) {
    return this.get({
      url: '/api/v1/xreports/public/share-link/token',
      params,
    })
  }
  // 检查是否已有生成，请求taskid，等多合一
  checkPreviousResult(data) {
    return this.post({
      url: '/api/v1/general/warn/ai/solution',
      data,
    })
  }
  relinkGetTaskId(data) {
    return this.post({
      url: '/api/v1/general/ai-analysis/retry',
      data,
    })
  }
}

export default new ActionRecordService()
